/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Error,
  StoreListResponse,
  StoreLocalizationRequest,
  StoreLocalizationResponse,
  StoreRequest,
  StoreResponse,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Stores<
  SecurityDataType = unknown,
> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Store
   * @name GetStores
   * @request GET:/stores
   * @secure
   */
  getStores = (
    query?: {
      /** Sort by attributes ascending (asc) or descending (desc) */
      sort?: string;
      /** Return page/pageSize (default: true) */
      "pagination[withCount]"?: boolean;
      /** Page number (default: 0) */
      "pagination[page]"?: number;
      /** Page size (default: 25) */
      "pagination[pageSize]"?: number;
      /** Offset value (default: 0) */
      "pagination[start]"?: number;
      /** Number of entities to return (default: 25) */
      "pagination[limit]"?: number;
      /** Fields to return (ex: title,author) */
      fields?: string;
      /** Relations to return */
      populate?: string;
      /** Filters to apply */
      filters?: Record<string, any>;
      /** Locale to apply */
      locale?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<StoreListResponse, Error>({
      path: `/stores`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Store
   * @name PostStores
   * @request POST:/stores
   * @secure
   */
  postStores = (data: StoreRequest, params: RequestParams = {}) =>
    this.request<StoreResponse, Error>({
      path: `/stores`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Store
   * @name GetStoresId
   * @request GET:/stores/{id}
   * @secure
   */
  getStoresId = (id: number, params: RequestParams = {}) =>
    this.request<StoreResponse, Error>({
      path: `/stores/${id}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Store
   * @name PutStoresId
   * @request PUT:/stores/{id}
   * @secure
   */
  putStoresId = (id: number, data: StoreRequest, params: RequestParams = {}) =>
    this.request<StoreResponse, Error>({
      path: `/stores/${id}`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Store
   * @name DeleteStoresId
   * @request DELETE:/stores/{id}
   * @secure
   */
  deleteStoresId = (id: number, params: RequestParams = {}) =>
    this.request<number, Error>({
      path: `/stores/${id}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Store
   * @name PostStoresIdLocalizations
   * @request POST:/stores/{id}/localizations
   * @secure
   */
  postStoresIdLocalizations = (
    id: number,
    data: StoreLocalizationRequest,
    params: RequestParams = {},
  ) =>
    this.request<StoreLocalizationResponse, Error>({
      path: `/stores/${id}/localizations`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
